var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-upload" },
    [
      _c("c-uploader", {
        ref: "uploader",
        staticClass: "custom v-mt-lg",
        attrs: {
          multiple: "",
          "no-thumbnails": "",
          "hide-underline": "",
          url: "",
          method: "PUT",
          "url-factory": _vm.getUploadURL,
          "upload-factory": _vm.uploadFile,
          "send-raw": true,
          headers: { authorization: "Bearer " + _vm.userToken },
          after: [],
          "auto-expand": true,
          "expand-class": "files-to-upload",
          secureToken: this.secureToken,
          userToken: this.userToken,
          isMobile: _vm.isMobile
        },
        on: {
          finish: _vm.uploaded,
          batchFailed: _vm.batchFailed,
          passwordFailed: _vm.passwordFailed,
          abort: _vm.aborted,
          start: function($event) {
            return _vm.$emit("uploadStarted")
          },
          fileReadStart: function($event) {
            return _vm.$emit("fileReadStart")
          },
          fileReadStop: function($event) {
            return _vm.$emit("fileReadStop")
          },
          add: function($event) {
            return _vm.$emit("fileReadStop")
          },
          filesToUpload: function(files) {
            return _vm.$emit("filesToUpload", files)
          }
        },
        model: {
          value: _vm.files,
          callback: function($$v) {
            _vm.files = $$v
          },
          expression: "files"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }